<template>
  <div class="block p-4">
    <div class="flex justify-between items-center flex-grow">
      <div class="flex items-center space-x-3">
        <o-avatar :items="[product.product]" size="md" />
        <div>
          <h5 class="font-medium">
            {{ product.displayLabel }}
          </h5>
          <p class="text-sm">
            {{ dateLabel }}
          </p>
        </div>
      </div>

      <div class="flex items-center">
        <o-tooltip :text="$t('order.view')">
          <o-panel-link tag="o-button" flat size="sm" icon="sale" :path="`/order/${product.order.idOrder}`" />
        </o-tooltip>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  OAvatar,
} from '@/components/elements'

interface Props {
  product: Record<string, any>
}

const props = defineProps<Props>()

const { $date } = useNuxtApp()

const dateLabel = computed(() => {
  const date = props.product.order.date
  return ($date as any).format(date * 1000, ($date as any).presets.full)
})
</script>
